/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetupParameters } from '../../models/setup-parameters';

export interface GetSetupParameters$Params {
  productionOrderId: number;
}

export function getSetupParameters(http: HttpClient, rootUrl: string, params: GetSetupParameters$Params, context?: HttpContext): Observable<StrictHttpResponse<SetupParameters>> {
  const rb = new RequestBuilder(rootUrl, getSetupParameters.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SetupParameters>;
    })
  );
}

getSetupParameters.PATH = '/api/v1/SetupParameter/GetSetupParameters/{productionOrderId}';
